import React from 'react';
import {Props} from '@src/components/Form/FormField';
import {IProductModel} from '@src/@interfaces/models/Product/IProductModel';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const SetsOfVariablesField = React.lazy(() => import('@views/products/fields/SetsOfVariablesField'));

export default function SetsOfVariablesLazyField(props: Props<IProductModel>) {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <SetsOfVariablesField {...props}/>
    </React.Suspense>;
}
